import { ProductModelDetail } from './../services/product_services';
import { CategoryModel, IListCategoryServices } from './../services/listCategory_services';
import { observable, runInAction } from 'mobx';
import { IProductServices, ProductDetail, ProductModel } from 'services/product_services';

export type ProductStore = {
  productSearch: ProductModelDetail;
  product: {
    data: Array<ProductModel>;
    message: string;
    isSuccess: boolean;
    recordsTotal: number;
    resultsCount: number;
    pagesCount: number;
  };
  listParentCategory: {
    data: Array<CategoryModel>;
    message: string;
    isSuccess: boolean;
  };
  listCategory: {
    data: Array<CategoryModel>;
    message: string;
    isSuccess: boolean;
  };
  listCategoryDetail: {
    data: Array<CategoryModel>;
    message: string;
    isSuccess: boolean;
  };
  listCategory2Detail: {
    data: Array<CategoryModel>;
    message: string;
    isSuccess: boolean;
  };
  getProductDetailByIdResponse: {
    data?: ProductDetail;
    message: string;
    isSuccess: boolean;
  };
  editProductResponse: {
    message: string;
    isSuccess: boolean;
  };
};

export interface IProductPresenter {
  createStore(): ProductStore;
  getListProduct(store: ProductStore, data: object): Promise<void>;
  getListCategory(
    store: ProductStore,
    keyword: string,
    parentCateId: string | null,
    CateId: string | null,
    type: number,
  ): Promise<void>;
  getProductDetailById(store: ProductStore, id: string): Promise<void>;
  editProduct(store: ProductStore, data: object): Promise<void>;
  setSearchState(store: ProductStore, data: ProductModelDetail): Promise<void>;
  exportExcelProduct(data: object): Promise<void>;
}

export function createProductPresenter(
  {
    productServices,
  }: {
    productServices: IProductServices;
  },
  {
    listCategoryServices,
  }: {
    listCategoryServices: IListCategoryServices;
  },
): IProductPresenter {
  return {
    createStore: (): ProductStore =>
      observable({
        //khoi tao gtri ban dau
        productSearch: {
          productCode: '',
          productName: '',
          categoryId: null,
          parentCategoryId: null,
          parentCategory: null,
          categoryDetailId: null,
          categoryDetail2Id: null,
          hasRouting: null,
          actived: null,
          statusMold: '',
          isExpiredDate: null,
          isTooManyTimes: null,
          bin: '',
          currentBin: '',
          locationNote: '',
          specification: '',
          size: '',
          status: '',
          printMoldFilm: '',
          printMoldName: '',
          knifeType: '',
          equipmentType: '',
          productNum: '',
          vendor: '',
          oldcode: '',
          stampQuantity: '',
          currentStampQuatity: '',
          moldTest: '',
        },
        product: {
          data: [],
          message: '',
          isSuccess: false,
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        listParentCategory: {
          data: [],
          message: '',
          isSuccess: false,
        },
        listCategory: {
          data: [],
          message: '',
          isSuccess: false,
        },
        listCategoryDetail: {
          data: [],
          message: '',
          isSuccess: false,
        },
        listCategory2Detail: {
          data: [],
          message: '',
          isSuccess: false,
        },
        getProductDetailByIdResponse: {
          data: undefined,
          message: '',
          isSuccess: false,
        },
        editProductResponse: {
          message: '',
          isSuccess: false,
        },
      }),

    getListProduct: async (store, data) => {
      try {
        const result = await productServices.getListProduct(data);
        runInAction(() => {
          store.product.data = result.data;
          store.product.message = result.message;
          store.product.isSuccess = result.isSuccess;
          store.product.pagesCount = result.pagesCount;
          store.product.recordsTotal = result.recordsTotal;
          store.product.resultsCount = result.resultsCount;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getListCategory: async (store, keyword, parentCateId, CateId, type) => {
      try {
        const result = await listCategoryServices.getListCategory(keyword, parentCateId, CateId, type);
        runInAction(() => {
          if (type === 1) {
            store.listParentCategory.data = result.data;
            store.listParentCategory.isSuccess = result.isSuccess;
            store.listParentCategory.message = result.message;
          } else if (type === 2) {
            store.listCategory.data = result.data;
            store.listCategory.isSuccess = result.isSuccess;
            store.listCategory.message = result.message;
          } else if (type === 3) {
            store.listCategoryDetail.data = result.data;
            store.listCategoryDetail.isSuccess = result.isSuccess;
            store.listCategoryDetail.message = result.message;
          } else {
            store.listCategory2Detail.data = result.data;
            store.listCategory2Detail.isSuccess = result.isSuccess;
            store.listCategory2Detail.message = result.message;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    getProductDetailById: async (store, id) => {
      try {
        const result = await productServices.getProductDetailById(id);
        runInAction(() => {
          store.getProductDetailByIdResponse.data = result.data;
          store.getProductDetailByIdResponse.isSuccess = result.isSuccess;
          store.getProductDetailByIdResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    editProduct: async (store, data) => {
      try {
        const result = await productServices.editProduct(data);
        runInAction(() => {
          store.editProductResponse.isSuccess = result.isSuccess;
          store.editProductResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    setSearchState: async (store, data) => {
      try {
        runInAction(() => {
          store.productSearch = data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    exportExcelProduct: async (data: object) => {
      try {
        await productServices.exportExcelProduct(data);
      } catch (error) {
        console.log(error);
      }
    },
  };
}
